import React, { useState, useEffect } from 'react'
import { Modal, Checkbox } from "antd";
import {
  FormWrapperInputComponent, StatusComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Input from "../../../../../common/component/Input";
import TextArea from '../../../../../common/component/TextArea';
import { cloneDeep, merge } from 'lodash'
import { capitalizeFirstLetter, formatMoney, formatValidation, multipleValidate } from '../../../../../../../helpers/functions';
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect';
import { ORDER } from '../../../../../../../constants/Define';
import classNames from 'classnames';
import PartiallyCashBack from './PartiallyCashBack';
import { BACK_TARGET, REFUND_TYPE } from './constants';

const CheckboxGroup = Checkbox.Group

const OrderTourItemDetail = ({
  title = '',
  visible = false,
  item = {},
  onSave = (data) => { },
  onClose = () => { },
  t,
  itemTypes,
  rateCodeDetail = {},
  orderState = {}
}) => {
  const [status, setStatus] = useState(item.status)
  const [operaBooking, setOperaBooking] = useState(item.operaBooking)
  const [note, setNote] = useState(item.note)
  const [currStatus, setCurrStatus] = useState(null)
  const [rateCodeProduct, setRateCodeProduct] = useState([])
  const [refundProductIds, setRefundProductIds] = useState(item.refundProductIds)
  const [isPass, setIsPass] = useState(true)
  const [partiallyRefundData, setPartiallyRefundData] = useState({})
  const [partiallyRefundValidation, setPartiallyRefundValidation] = useState({})

  const validatePartiallyRefund = () => {
    let validate = {
      required: {
      }
    };

    let valueValidate = {}

    const isPartiallyCashBack = status === 4 && currStatus !== 7
    if (!isPartiallyCashBack) return false
    const {
      RefundType,
      Name,
      CreditPointRateCode,
      backTarget,
      RefundTo,
      Amount = 0,
    } = partiallyRefundData
    if (!RefundType || RefundType === REFUND_TYPE.CASH_BACK) return false
    const result = []

    if (!Amount || Amount === 0){
      result.push(false)
      validate.required.backValue = formatValidation(t('validation.statusCode.code.8006'), t(`item.tour.partialyCashBack.lblBackValue`))
    }
    if (!Name) {
      result.push(false)
      validate.required.Name = formatValidation(t('validation.statusCode.code.1'), t(`item.tour.partialyCashBack.lblTypeName`))
    } else {
      result.push(true)
      validate.required.Name = null
    }
    if (!CreditPointRateCode) {
      result.push(false)
      validate.required.CreditPointRateCode = formatValidation(t('validation.statusCode.code.1'), t(`item.tour.partialyCashBack.lblLoyaltyCode`))
    } else {
      result.push(true)
      const { CreditPointRateCode, ...nextRequired } = validate.required
      validate.required = nextRequired
    }
    if (backTarget === BACK_TARGET.OTHER && !RefundTo) {
      result.push(false)
      validate.required.RefundTo = formatValidation(t('validation.statusCode.code.1'), t(`item.tour.partialyCashBack.lblSentPointToEmail`))
    } else {
      result.push(true)
      const { RefundTo, ...nextRequired } = validate.required
      validate.required = nextRequired
    }
    const validateResult = multipleValidate(partiallyRefundData, validate, valueValidate);
    setPartiallyRefundValidation(validateResult);
    return result.some(f => f === false)
  }
  const onSubmit = () => {
    const data = cloneDeep(item);
    let isPassSubmit = true;
    if(status === 7 && (!refundProductIds || (refundProductIds && refundProductIds.length === 0))){
      isPassSubmit = false;
      setIsPass(false)
    }
    const invalidPartiallyRefund = validatePartiallyRefund()
    if (invalidPartiallyRefund) {
      isPassSubmit = false;
    }
    if(isPassSubmit){
      let statusTmp = status;
      const {
        RefundType,
        Name,
        Amount,
        CreditPointRateCode,
        backTarget,
        RefundTo
      } = partiallyRefundData
      // if(status === 7 && refundProductIds.length === rateCodeProduct.length){
      //   statusTmp = 4;
      // }
      const RefundDetail = RefundType === REFUND_TYPE.POINT_BACK ? {
        Name,
        Amount,
        CreditPointRateCode,
        RefundTo: backTarget === BACK_TARGET.OTHER ? RefundTo : null
      } : undefined
      return onSave(merge(data, {
        status: statusTmp,
        operaBooking,
        note,
        refundProductIds,
        RefundType,
        RefundDetail
      }))
    }
  }

  useEffect(() => {
    if (item) {
      setStatus(item.status)
      setOperaBooking(item.operaBooking)
      setNote(item.note)
      setCurrStatus(item.status)
      setRefundProductIds(item.refundProductIds)
    }
  }, [item])

  useEffect(() => {
    if (rateCodeDetail && rateCodeDetail.rateCodeProducts) {
      setRateCodeProduct(rateCodeDetail.rateCodeProducts)
    }
  }, [rateCodeDetail])

  useEffect(() => {
    if (!visible) {
      setPartiallyRefundValidation({})
      setPartiallyRefundData({})
    }
  }, [visible])

  const isPartiallyCashBack = status === 4 && currStatus !== 7
  const sumRefundCost = rateCodeDetail && Number(rateCodeDetail?.sellCost);
  const email = orderState?.detail?.order?.email;
  const bookerEmail = orderState?.detail?.order.bookerEmail;
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={() => onSubmit()}
      onCancel={onClose}
      okText={t('action.save')}
      cancelText={t('action.cancel')}
      destroyOnClose={true}
    >

      <Wrapper className='col-md-12'>
        <Wrapper>
          {item.tourName}
        </Wrapper>
        <Wrapper>
          <FormWrapperInputComponent
            labelTitle={capitalizeFirstLetter(t(`item.order.tourStatus`))}
          >
            {status && (ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus]) ? 
                <AntSelect className="select-enum"
                showArrow
                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.order.tourStatus`)).toLowerCase())}
                value={t(`item.order.orderItemStatus.${status}`)}
                onChange={setStatus}
                style={{ width: '100%' }}
                >
                <AntOption key={currStatus} value={currStatus}>{`${t(`item.order.orderItemStatus.${currStatus}`)} (${t('item.order.currentStatus')})`}</AntOption>
                {(ORDER.ORDER_ITEM_STATUS).map(status => 
                    currStatus && !(item.isLocked && status === 3) &&  ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus].includes(status) && <AntOption key={status} value={status}>{t(`item.order.orderItemStatus.${status}`)}</AntOption>
                )}
                </AntSelect>
                : 
                <p><StatusComponent color={t(`item.order.orderItemStatusColor.${currStatus}`)}
                label={t(`item.order.orderItemStatus.${currStatus}`)} /></p>
            }
            {/* {
              status === 7 && status && (ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus]) &&
              <div className={ classNames(`col-md-12 mt-2`, {
                'border-red': !isPass && (!refundProductIds || (refundProductIds && refundProductIds.length === 0))
              }) }>
                <CheckboxGroup
                  style={{display: 'flex', flexFlow: 'column'}}
                  className="m-t m-b"
                  options={ rateCodeProduct.map(item => {
                    return{
                      value: item.id,
                      label: `${item.name} | ${formatMoney(item.cost)}`
                    }
                  }) }
                  value={refundProductIds}
                  onChange={ (event)=> setRefundProductIds(event) }
                />
              </div>
            } */}
          </FormWrapperInputComponent>
          {
            isPartiallyCashBack && <PartiallyCashBack
              t={t}
              isPass={isPass}
              partiallyRefundData={partiallyRefundData}
              validation={partiallyRefundValidation}
              operaBooking={operaBooking}
              note={note}
              setPartiallyRefundData={setPartiallyRefundData}
              setOperaBooking={setOperaBooking}
              setNote={setNote}
              sumRefundCost={sumRefundCost}
              status={status}
              email={bookerEmail ? bookerEmail : email}
              isLoginedEmail={orderState?.detail?.order.isLoginedUser}
            />
          }
          {
            !isPartiallyCashBack && <>
              <FormWrapperInputComponent
                labelTitle={t(`item.order.operaBooking`)}
              >
                <Input placeholder={t(`item.order.operaBooking`)}
                  type={`text`}
                  className={`form-control`}
                  name={`operaBooking`}
                  onChange={(e) => setOperaBooking(e.target.value)}
                  value={operaBooking} />
              </FormWrapperInputComponent>

              <FormWrapperInputComponent
                labelTitle={t(`item.order.note`)}
              >
                <TextArea value={note}
                  placeholder={t(`item.order.note`)}
                  name={`note`}
                  onChange={e => setNote(e.target.value)} />
              </FormWrapperInputComponent>
            </>
          }
          
        </Wrapper>
      </Wrapper>
    </Modal>
  )
}

export default OrderTourItemDetail;